import React, { useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import { TooltipButton } from 'spw-shared/globalComponents';
import ShowTooltipIcon from 'spw-static/images/tooltip-icon.svg';
import {
  HeadcountSourceTooltip,
  TooltipContainer,
  TooltipText,
  TooltipTitle,
} from 'spw-esa-projects/program-summary/styles';

export const HeadcountLevelTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setShowTooltip(false);
      }}
    >
      <HeadcountSourceTooltip
        style={{ maxWidth: 333 }}
        title={
          <TooltipContainer>
            <TooltipTitle>HEADCOUNT SOURCE</TooltipTitle>
            <TooltipText>
              <p>Go to the Headcount page to make changes to these inputs.</p>
              <p style={{ marginBottom: 0 }}>
                Whichever source is selected will be used for all project data
                and associated benchmark reports.
              </p>
            </TooltipText>
          </TooltipContainer>
        }
        placement="bottom-end"
        disableHoverListener
        disableFocusListener
        disableTouchListener
        open={showTooltip}
        PopperProps={{
          popperOptions: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  enabled: true,
                  offset: [0, -8],
                },
              },
            ],
          },
        }}
      >
        <TooltipButton
          theme={{ show: showTooltip }}
          onClick={() => setShowTooltip(!showTooltip)}
        >
          <img alt="tooltip-icon" src={ShowTooltipIcon} />
        </TooltipButton>
      </HeadcountSourceTooltip>
    </ClickAwayListener>
  );
};
